// import { useNavigate } from 'react-router-dom'
// import { React, useState, useEffect } from 'react';
// import { Box, Typography, Link, useMediaQuery } from "@mui/material";
// import 'slick-carousel/slick/slick.css';
// import 'slick-carousel/slick/slick-theme.css';

// const imagePaths = [
//     "media/main/main2.jpg",
//     "media/main/main3.jpg",
//     // "media/main/main16.jpg",
//     // "media/main/main15.jpg",
//     "media/main/main44.jpg",
//     "media/main/main55.jpg",
//     "media/main/main1.jpg",
//     "media/main/main7.jpg",
//     "media/main/main88.jpg",
//     "media/main/main9.jpg",
//     "media/main/main10.jpg",
//     "media/main/main11.jpg",
// ];

// const SliderCover = () => {
//     const isMobile = useMediaQuery('(max-width:600px)');
//     const [currentImageIndex, setCurrentImageIndex] = useState(0);
//     const [opacity, setOpacity] = useState(1);
//     const navigate = useNavigate(); 

//     useEffect(() => {
//         const intervalId = setInterval(() => {
//             setOpacity(0.3); // Затемнение до 30%, чтобы не было полного исчезновения

//             setTimeout(() => {
//                 setCurrentImageIndex((prevIndex) => 
//                     prevIndex === imagePaths.length - 1 ? 0 : prevIndex + 1
//                 );

//                 setOpacity(1); // Быстро возвращаем яркость
//             }, 300); // Быстрый переход (0.3 секунды)
//         }, 5000);

//         return () => clearInterval(intervalId);
//     }, []);

//     return (
//         <Box position="relative" height="75vh" overflow="hidden">
//             <img
//                 src={imagePaths[currentImageIndex]}
//                 alt="Плакат сайта"
//                 style={{
//                     width: '100%',
//                     height: '100%',
//                     objectFit: 'cover',
//                     transition: 'opacity 0.3s ease-in-out', // Ускоряем анимацию
//                     opacity: opacity, 
//                 }}
//             />
//             <div
//                 style={{
//                     position: "absolute",
//                     top: 0,
//                     left: 0,
//                     width: "100%",
//                     height: "100%",
//                     backgroundColor: "rgba(0, 0, 0, 0.5)", // Лёгкое затемнение поверх картинки
//                     transition: 'opacity 0.3s ease-in-out',
//                     opacity: opacity,
//                 }}
//             />
//             <Box
//                 sx={{
//                     position: "absolute",
//                     top: "50%",
//                     left: "50%",
//                     transform: "translate(-50%, -50%)",
//                     textAlign: "center",
//                     color: "#fff",
//                     zIndex: 1,
//                 }}
//             >
//                 <Typography variant={isMobile ? "h4" : "h3"} gutterBottom>
//                     {/* Выбери правильную траекторию развития ребенка */}
//                     Профориентация, развитие компетенций и карьерного самоопределения школьников
//                     {/* Профориентация, современные лаборатории, инженерные и цифровые направления, развитие навыков будущего */}
//                 </Typography>
//                 <Typography variant="h5" gutterBottom>
//                     {/* Пройди тест и выбери по интересам, навыкам образовательную программу */}
//                 </Typography>
//                 <button className='custom-button' onClick={() => navigate("/learn")}>
//                     Записаться
//                 </button>
//             </Box>
//         </Box>
//     );
// };

// export default SliderCover;
import { useNavigate } from 'react-router-dom'
import { React, useState, useEffect, useRef } from 'react';
import { Box, Typography, Link, useMediaQuery } from "@mui/material";
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const imagePaths = [
    "media/main/main2.jpg",
    "media/main/main3.jpg",
    // "media/main/main16.jpg",
    // "media/main/main15.jpg",
    "media/main/main44.jpg",
    "media/main/main55.jpg",
    "media/main/main1.jpg",
    "media/main/main7.jpg",
    "media/main/main88.jpg",
    "media/main/main9.jpg",
    "media/main/main10.jpg",
    "media/main/main11.jpg",
];

const SliderCover = () => {
    const isMobile = useMediaQuery('(max-width:600px)');
    const [currentImageIndex, setCurrentImageIndex] = useState(0);
    const [opacity, setOpacity] = useState(1);
    const navigate = useNavigate();
    
    // Используем ref для отслеживания состояния монтирования
    const isMounted = useRef(true);

    useEffect(() => {
        let timeoutId;
        
        const switchImage = () => {
            // Проверяем, что компонент всё ещё смонтирован
            if (!isMounted.current) return;
            
            // Затемняем изображение
            setOpacity(0.3);
            
            // Через 300мс меняем картинку и возвращаем яркость
            timeoutId = setTimeout(() => {
                if (!isMounted.current) return;
                
                setCurrentImageIndex((prevIndex) => 
                    prevIndex === imagePaths.length - 1 ? 0 : prevIndex + 1
                );
                setOpacity(1);
                
                // Запускаем следующий цикл через 5 секунд
                timeoutId = setTimeout(switchImage, 5000);
            }, 300);
        };
        
        // Запускаем первый цикл через 5 секунд после монтирования
        timeoutId = setTimeout(switchImage, 5000);
        
        // Очистка при размонтировании
        return () => {
            isMounted.current = false;
            clearTimeout(timeoutId);
        };
    }, []);

    return (
        <Box position="relative" height="75vh" overflow="hidden">
            <img
                src={imagePaths[currentImageIndex]}
                alt="Плакат сайта"
                style={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover',
                    transition: 'opacity 0.3s ease-in-out',
                    opacity: opacity, 
                }}
            />
            <div
                style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    backgroundColor: "rgba(0, 0, 0, 0.5)",
                    transition: 'opacity 0.3s ease-in-out',
                    opacity: opacity,
                }}
            />
            <Box
                sx={{
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    textAlign: "center",
                    color: "#fff",
                    zIndex: 1,
                }}
            >
                <Typography variant={isMobile ? "h4" : "h3"} gutterBottom>
                    Профориентация, развитие компетенций и карьерного самоопределения школьников
                </Typography>
                <Typography variant="h5" gutterBottom>
                </Typography>
                <button className='custom-button' onClick={() => navigate("/learn")}>
                    Записаться
                </button>
            </Box>
        </Box>
    );
};

export default SliderCover;